import { DetailService } from '@core/services/detail.service';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { Breakdown, AdditionalCharge, PriceClarification, AdditionalInformation } from '@core/models/breakdown/breakdown.interface';
import { take } from 'rxjs/operators';
import { CurrencyCode } from '@shared/enums/currency-code.enum';
import { CurrencyPipe } from '@shared/pipes/currency.pipe';
import { MbExpandablePanel, MbProgressBarModule, MbExpandablePanelModule, MbIconTextModule, MbIconModule } from '@am/moebius';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'am-pricing-expandable',
    templateUrl: './pricing-expandable.component.html',
    styleUrls: ['./pricing-expandable.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        NgFor,
        MbProgressBarModule,
        MbExpandablePanelModule,
        MbIconTextModule,
        MbIconModule,
        CurrencyPipe,
    ],
})
export class PricingExpandableComponent {
  public readonly USD_CODE = CurrencyCode.USD;

  @Input() rateId = '';
  @Input() fop = '';
  @Input() isExperts = false;
  @Input() currencyCode = '';
  @Input() currencyLabel = '$';

  @Output() collapsed: EventEmitter<boolean> = new EventEmitter();

  @ViewChild('expandablePanel') private expandablePanel: MbExpandablePanel;

  public breakdown: Breakdown;
  public rate: AdditionalCharge | PriceClarification;
  public charges: AdditionalCharge[];
  public information: AdditionalInformation;
  public isPanelExpanded = false;
  public showLoader = false;

  constructor(
    private detailService: DetailService,
    private cdr: ChangeDetectorRef,
  ) {}

  private getBreakdownHotel() {
    if (this.breakdown !== undefined) {
      this.isPanelExpanded = true;
      this.expandablePanel.open();
    } else {
      this.showLoader = true;
      this.cdr.markForCheck();
      this.detailService
        .getHotelBreakdown(this.rateId, this.currencyCode)
        .pipe(take(1))
        .subscribe((data) => {
          this.breakdown = data[0];
          if (this.breakdown !== undefined) {
            this.rate =
              this.fop === 'PAY_AT_DESTINATION'
                ? this.breakdown.price_clarification
                : this.breakdown.detail.rates[0];
            this.charges = this.breakdown.detail.charges;
            this.showLoader = false;
            if (this.breakdown?.additional_information) this.information = this.breakdown?.additional_information[0];
            this.isPanelExpanded = true;
            this.cdr.detectChanges();
            this.expandablePanel.open();
          }
        });
    }
  }

  public toggle() {
    if (!this.isPanelExpanded) {
      this.getBreakdownHotel();
    } else {
      this.isPanelExpanded = false;
      this.expandablePanel.close();
      this.collapsed.emit(true);
      this.cdr.markForCheck();
    }
  }
}
